
import { defineComponent, provide } from 'vue'
import { Accordion } from './DashboardAccordion.types'

export default defineComponent({
  setup() {
    provide<Accordion>('Accordion', {
      active: null,
    })
  },
})
